<template>
  <div class="container center w100 relative-container">
    <div class="padded">
      <div>
        <wrap-container class="cascade w50">
          <form-validator>
            <wrap-container>
              <p
                id="titulo"
                class="titulo p32 medium oscuro"
                v-safe-html="config.pasos.renaperConfirmar.titulo"
              />
              <p
                id="subtitulo"
                class="te-pedimos"
                v-safe-html="config.pasos.renaperConfirmar.subtitulo"
              />
              <wrap-container class="grey-container">
                <wrap-container
                  v-for="(item, index) in displayTable"
                  :key="`table-${index}`"
                  class="row grid-container grid-container--6-6"
                >
                  <div class="col1">
                    <p>{{ item[0].label }}</p>
                    <p>
                      <strong
                        ><span data-obfuscate>{{ item[0].value }}</span></strong
                      >
                    </p>
                  </div>
                  <div class="col2" v-if="item[1]">
                    <p>{{ item[1].label }}</p>
                    <p>
                      <strong
                        ><span data-obfuscate>{{ item[1].value }}</span></strong
                      >
                    </p>
                  </div>
                </wrap-container>
                <wrap-container>
                  <custom-link
                    @click.native="modificarDatos"
                    label="Modificar"
                  />
                </wrap-container>
              </wrap-container>
            </wrap-container>
            <div class="sn-mobile">
              <step-navigator router-push />
            </div>
          </form-validator>
        </wrap-container>
        <wrap-container class="cascade w50"></wrap-container>
      </div>
    </div>
  </div>
</template>

<script>
import get from "lodash/get";
import WrapContainer from "@/components/core/Container";
import StepNavigator from "@/components/core/StepNavigator";
import FormValidator from "@/components/core/FormValidator";
import CustomLink from "@/components/core/CustomLink";
import {
  byValue,
  generos,
  nacionalidades,
  tiposDocumento,
  tiposDocumentos
} from "@/config/constants";

export default {
  name: "RenaperConfirmar",
  components: {
    WrapContainer,
    FormValidator,
    CustomLink,
    StepNavigator
  },
  data() {
    return {
      consulta: this.$store.getters.getConsulta()
    };
  },
  methods: {
    modificarDatos() {
      this.$router.go(-1);
    }
  },
  computed: {
    displayTable() {
      const tipoResidencia =
        this.consulta.tipoDoc === tiposDocumentos.DNE
          ? { label: "Tipo de residencia", value: this.consulta.tipoResidencia }
          : undefined;
      return [
        [
          { label: "Nombre", value: this.consulta.nombre },
          { label: "Apellido", value: this.consulta.apellido }
        ],
        [
          {
            label: "Tipo de documento",
            value: get(
              byValue(this.consulta.tipoDoc, tiposDocumento),
              "label",
              "-"
            )
          },
          { label: "DNI", value: this.consulta.numeroDoc }
        ],
        [
          {
            label: "Fecha de nacimiento",
            value: this.consulta.fechaNacimiento
          },
          {
            label: "Género según DNI",
            value: get(byValue(this.consulta.sexo, generos), "label", "-")
          }
        ],
        [
          {
            label: "Nacionalidad",
            value: get(
              byValue(this.consulta.nacionalidad, nacionalidades),
              "label",
              "-"
            )
          },
          tipoResidencia
        ]
      ];
    }
  }
};
</script>

<style scoped>
div.grey-container {
  background-color: #f4f4f4;
  padding: 24px 32px;
  margin: 30px 0 !important;
}

div.row p {
  margin-top: 0;
  margin-bottom: 5px;
}

div.row:last-child {
  margin-bottom: 0 !important;
}

@media screen and (max-width: 600px) {
  #titulo {
    font-size: 26px;
  }

  .sn-mobile {
    max-width: 600px;
    width: 100%;
    bottom: 0;
    margin-right: 50px;
    padding-right: 35px;
  }
}

@media screen and (min-width: 600px) and (max-width: 1024px) {
  .w50 {
    width: 80%;
    max-width: 1024px;
    margin-left: 10%;
    margin-right: 10%;
  }

  .cascade {
    display: block;
  }
}
</style>
